import { BaseModel } from './BaseModel';
// import Post from "./Post";
import Section from './Section';
import Post from './Post';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import ForumLiker from './ForumLiker';
export class Forum extends BaseModel {
  static get entity() {
    return 'forums';
  }

  static get fk() {
    return 'forum_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      topic: this.attr(null),
      count_replies: this.number(0),
      count_views: this.number(0),
      is_default: this.boolean(false),
      section_id: this.attr(null),
      section: this.belongsTo(Section, 'section_id'),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id'),
      description: this.attr(null),
      images: this.attr([]),
      liked_id: this.attr(null),
      liked: this.belongsTo(ForumLiker, 'liked_id'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      edited_at: this.attr(null),
      count_likes: this.number(0)
    };
  }

  static apiConfig = {
    actions: {
      fetchForumsBySection(sectionId) {
        return this.get(`/sections/${sectionId}/forums`);
      },
      fetchById(forumId) {
        return this.get(`/forums/${forumId}`);
      },
      update(forumId, body) {
        return this.put(`/forums/${forumId}`, body);
      },
      increaseForumView(forumId) {
        return this.put(`/forums/${forumId}/view`);
      },
      likeForum(forumId) {
        return this.put(`/forums/${forumId}/like`);
      },
      unlikeForum(forumId) {
        return this.put(`/forums/${forumId}/unlike`);
      }
    }
  };

  get timestamp() {
    if (this.edited_at && this.created_at !== this.edited_at) {
      return datetimeMixin.methods.formatDynamicDateTime(new Date(this.edited_at)) + ' (edited)';
    } else {
      return datetimeMixin.methods.formatDynamicDateTime(new Date(this.created_at));
    }
  }
}

export default Forum;
